<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <div>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive">
            <!-- 这里是会被缓存的视图组件，比如 page1,page2 -->
          </router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive">
          <!-- 这里是不被缓存的视图组件，比如 page3 -->
        </router-view>
      </div>
    </transition>
    <div class="bottomBar" v-if="mttabbarshow && curPage.indexOf('topicList') == -1">
      <div class="tab" @click="toTab('homepage')">
        <img slot="icon" id="home1" src="./assets/img/homepage.png" v-if="curPage != 'homepage'">
        <img slot="icon" id="home" src="./assets/img/homepageAc.png" v-if="curPage == 'homepage'">
        首页
      </div>
      <div class="tab" @click="toTab('live')">
        <img slot="icon" src="./assets/img/live.png" v-if="curPage != 'live'">
        <img slot="icon" src="./assets/img/liveAc.png" v-if="curPage == 'live'">
        直播
      </div>
      <div class="tab" @click="toTab('meeting')">
        <img slot="icon" src="./assets/img/meeting.png" v-if="curPage != 'meeting'">
        <img slot="icon" src="./assets/img/meetingAc.png" v-if="curPage == 'meeting'">
        峰会
      </div>
      <div class="tab" @click="toTab('video')">
        <img slot="icon" src="./assets/img/video.png" v-if="curPage != 'video'">
        <img slot="icon" src="./assets/img/videoAc.png" v-if="curPage == 'video'">
        视频
      </div>
      <div class="tab" @click="toTab('mine')">
        <img slot="icon" src="./assets/img/mine.png">
        我的
      </div>
    </div>

  </div>
</template>

<script>
  // import {get_uid} from 'src/assets/js/common'
  export default {
    data () {
      return {
        selected: '',
        curPage: 'homepage'
      }
    },
    computed: {
      mttabbarshow: function () {
        return this.$store.state.mttabbarshow
      }
    },
    watch: {
      '$route' (to, from) {
        this.curPage = to.path.substr(1);
        console.log('当前页',this.curPage)
        if (this.curPage == '') {
          this.curPage = 'homepage'
        }
    }/*,
    selected(newV) {
      console.log('newV', newV);
      if (newV == 'mine') { // 个人中心在另外的项目中
        window.location.href = 'http://www.itdks.com/MobileMyInfo/myInfoIndex';
        return
      }
      this.src = './assets/img/' + newV + '.png';
    }
    */
  },
  created() {
    this.initData();
    // get_uid()
  },
  methods: {
    initData() {
      this.curPage =  this.$route.path.substr(1);
      if (this.curPage == '') {
        this.curPage = 'homepage'
      }
      if (window.location.href.indexOf('pathParams') > -1) { // 分享出去的
        var k = JSON.parse(decodeURIComponent(this.GetQueryString('pathParams')))
        console.log('k',(k));
        var params = k;
        var kk = $.param(params);
        window.location.href = '/#' + params.path + '?' + kk
        // this.$router.push({path: k.path, query: params})
      }
    },
    GetQueryString(name) {
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r!== null) { return unescape(r[2]); return null };
    },
    toTab(path) {
      if (path == 'mine') {
        window.location.href = 'https://www.itdks.com/MobileMyInfo/myInfoIndex';
        return
      }
      this.$router.push({path: '/' + path})
    },
}
}
</script>
<style lang="less">
.bottomBar{
  width: 100vw;
  height: 12vw;
  position: fixed;
  bottom: 0;
  z-index: 999;
  display: flex;
  background: white;
  box-sizing: border-box;
  border-top: 2px solid #ccc;
  div{
    flex: 1;
    text-align: center;
    line-height: 4vw;
    font-size: 3vw;
    img{
      width: 5.5vw;
      height: auto;
      display: block;
      margin: 1vw auto 1.2vw;
    }
  }
}
.mint-tab-item {
  padding: 20px 0 6px 0 !important;
  text-align: center;
  position: relative;
  img {
    width: 38px;
    height: 33px;
    position: absolute;
    left: 56px;
  }
}

.mint-tabbar{
  height: 94px;
  border-top: 2px solid #b7b7b7;
  position: fixed !important;
  bottom:0;
  box-sizing: border-box;
  margin-top: 94px;
  z-index:12;
}
.mint-tab-item-label {
 margin-top: 6px;
 font-size: 20px;/*px*/
 color: #666;
}
.mint-tab-item-icon{
  margin:0rem 0.92rem 0.066667rem 0.7rem;
}
.mint-tab-item-label {
  margin-top: 0.2rem;
}
.mint-tabbar > .mint-tab-item.is-selected{
  background: none;
}

.fade-enter-active,.fade-leave-active{
  transition: opacity 0.5s
}

/*元素移除的时候home,默认透明度1 --> 0*/
/*元素插入的时候news,默认透明度0 --> 1*/

/*插入元素之后的1不需要设置*/
.fade-entry,.fade-leave-to{
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue